module.exports = __webpack_public_path__ + "static/media/aib.5082fc64.png";